const EMPTY_SERVICE_VALUES = new Set([null, undefined, "", false]);

const normalizePermissionMatrix = (value) => {
  if ("grants" in value) return value;
  const ids = value.user_permission_id;
  const access = value.usermoduleaccess;
  if (!Array.isArray(ids) || !Array.isArray(access) || ids.length !== access.length) {
    throw new TypeError("Permission matrices must have matching rows");
  }
  const result = { user_permission_id: [], usermoduleaccess: [] };
  for (let row = 0; row < ids.length; row += 1) {
    if (ids[row] == null && access[row] == null) continue;
    if (!Array.isArray(ids[row]) || !Array.isArray(access[row]) ||
        access[row].length < ids[row].length ||
        access[row].slice(ids[row].length).some((item) => !EMPTY_SERVICE_VALUES.has(item))) {
      throw new TypeError("Permission matrices must align");
    }
    result.user_permission_id.push(ids[row]);
    result.usermoduleaccess.push(access[row].slice(0, ids[row].length));
  }
  return result;
};

export const normalizeStaffServiceIds = (value) => {
  const leaves = [];
  const visit = (item) => {
    if (Array.isArray(item)) {
      item.forEach(visit);
      return;
    }
    if (EMPTY_SERVICE_VALUES.has(item)) return;
    const number = typeof item === "number" ? item : Number(item);
    if (!Number.isSafeInteger(number) || number <= 0) {
      throw new TypeError("Staff service IDs must be positive integers");
    }
    leaves.push(number);
  };
  visit(value);
  return [...new Set(leaves)];
};

export const appendStaffFormValues = (formData, values) => {
  for (const [field, value] of Object.entries(values)) {
    if (field === "add_on_services") {
      const ids = normalizeStaffServiceIds(value);
      if (ids.length) formData.append(field, ids.join(","));
    } else if (field === "StaffUserPermission") {
      if (value && !Array.isArray(value) && typeof value === "object") {
        formData.append(field, JSON.stringify(normalizePermissionMatrix(value)));
      }
    } else if (field === "working_hours" && value && typeof value === "object") {
      formData.append(field, JSON.stringify(value));
    } else {
      formData.append(field, value);
    }
  }
  return formData;
};

export const staffUpdateAction = (values = {}) => {
  const id = Number(values.id);
  if (!Number.isSafeInteger(id) || id <= 0) {
    throw new TypeError("A valid staff ID is required for update");
  }
  return `afterlogin/staff/update/${id}`;
};
